import { MedicalInformationAttachment } from '@dreryk/egabinet-patient-medical-information-frontend-api';

const isVisible = ({ removed, editable }: MedicalInformationAttachment): boolean => !removed || (removed && editable);
const isNotRemoved = ({ removed }: MedicalInformationAttachment): boolean => !removed;

export const filterRemovedAttachments = (
   attachments: MedicalInformationAttachment[],
   showRemovedAttachments: boolean
): MedicalInformationAttachment[] => attachments.filter(showRemovedAttachments ? isVisible : isNotRemoved);
